<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    max-width="550px"
    style="z-index: 6"
    width="300"
    height="330"
  >
    <v-form ref="addCashRegisterForm" @submit.prevent="submit">
      <v-card
        class="overflow-auto"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }"
        style="border-radius:16px; overflow:hidden;"
      >
        <div class="modal-header">
          <v-icon color="#00BCD4" size="22" class="mr-2">mdi-cash-register</v-icon>
          <span class="modal-title">Blagajna</span>
          <v-spacer></v-spacer>
          <span class="modal-close-btn" @click="close">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <v-card-text>
          <v-row>
            <v-col class="pt-0">
              <v-text-field
                autofocus
                dense
                outlined
                label="Naziv"
                v-model="registerName"
                :rules="[rules.req]"
                class="form-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-text-field
                autocomplete="off"
                dense
                outlined
                label="Oznaka blagajne"
                hint="Samo brojevi"
                v-mask="'###########'"
                v-model="registerId"
                :rules="[rules.req, rules.reservedIds]"
                class="form-input"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-select
                dense
                outlined
                label="Vrsta blagajne"
                v-model="registerType"
                :items="registerTypes"
                :rules="[rules.req]"
                item-text="name"
                item-value="value"
                class="form-input"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <money-input
                dense
                outlined
                label="Polog na blagajni"
                v-model="deposit"
                ref="deposit"
                :currency="currency"
                class="form-input"
              >
              </money-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-select
                dense
                outlined
                label="Vrsta prijave na blagajnu"
                v-model="registerLoginType"
                :items="registerLoginTypes"
                :rules="[rules.req]"
                item-text="name"
                item-value="value"
                class="form-input"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-select
                dense
                outlined
                label="Nakon izdavanja računa"
                v-model="afterReceiptBehaviour"
                :items="afterReceiptBehaviours"
                :rules="[rules.req]"
                item-text="name"
                item-value="value"
                class="form-input"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="pb-0 pt-0">
            <v-col class="pb-0 pt-0">
              <v-select
                class="pb-3 form-input"
                outlined
                dense
                label="Odaberite printer"
                :items="printers"
                item-text="name"
                item-value="id"
                hide-details
                v-model="selectedPrinter"
                :rules="[rules.req]"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="modal-footer">
          <v-btn
            class="btn-create-modal"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            <v-icon size="16" color="white" class="mr-1">mdi-plus</v-icon>
            Dodaj blagajnu
          </v-btn>
        </div>
      </v-card>
    </v-form>
    <add-printer ref="addPrinter"></add-printer>
  </v-dialog>
</template>
<script>
import rules from '@/plugins/rules'
import { df, auth } from '@/plugins/firebase'
import { clone } from '@/plugins/utils'
import { v4 as uuidv4 } from 'uuid'
import state from '@/state'
import EventBus from '@/plugins/event-bus'
import MoneyInput from '@/components/MoneyInput'
import AddPrinter from '@/modules/point-of-sale/components/printer-configuration/AddPrinter'

export default {
  name: 'AddCashRegister',
  data: () => ({
    visible: false,
    submitting: false,
    deposit: '',
    error: {
      show: false,
      message: undefined
    },
    rules: {
      req: rules.req(),
      eq: rules.eq
    },
    registerName: undefined,
    registerId: undefined,
    registerType: undefined,
    registerTypes: [],
    registerLoginType: undefined,
    registerLoginTypes: [],
    afterReceiptBehaviour: undefined,
    afterReceiptBehaviours: [],
    printers: [],
    selectedPrinter: undefined,
    currency: 'EUR',
    listeners: []
  }),
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  components: { MoneyInput, AddPrinter },
  computed: {
    reservedIds () {
      return state.registerIds
    }
  },
  mounted () {
    this.rules.reservedIds = (val) =>
      !this.reservedIds.includes(parseInt(val)) ||
      `Blagajna s oznakom ${val} već postoji!`
    EventBus.$on('open-cash-register', () => this.open())
  },
  methods: {
    open () {
      const printers = []

      printers.push({ name: 'POS printer 58mm (T58)', value: 'T58', id: 'T58', library: 'NONE', width: 'T58' })
      printers.push({ name: 'POS printer 80mm (T80)', value: 'T80', id: 'T80', library: 'NONE', width: 'T80' })
      printers.push({ name: 'Klasični printer (A4)', value: 'A4', id: 'A4', library: 'NONE', width: 'A4' })

      const query = df
        .collection(`location_printers/${state.getPointOfSale().id}/printers`)
      const listener = query
        .onSnapshot((doc) => {
          doc.docs.forEach((rec) => {
            printers.push(rec.data())
          })
          this.printers = clone(printers.sort((a, b) => a.name.localeCompare(b.name)))
        })

      this.listeners.push(listener)
      this.deposit = ''
      this.visible = true
      this.submitting = false
      // const dooType = ['doo', 'jdoo'].includes(state.getCurrentCompany().type)
      this.registerTypes = [
        {
          name: this.$t('$vuetify.cashRegister.registerTypes.mp'),
          value: 'MP',
          disabled: !state.getCurrentCompany().certificate
        },
        {
          name: this.$t('$vuetify.cashRegister.registerTypes.vp'),
          value: 'VP'
        },
        {
          name: this.$t('$vuetify.cashRegister.registerTypes.all'),
          value: 'ALL',
          disabled: !state.getCurrentCompany().certificate
        }
      ]

      this.registerLoginTypes = [
        {
          name: this.$t('$vuetify.cashRegister.registerLoginTypes.default'),
          value: 'DEFAULT'
        },
        {
          name: this.$t('$vuetify.cashRegister.registerLoginTypes.selectUser'),
          value: 'SELECT_USER'
        },
        {
          name: this.$t('$vuetify.cashRegister.registerLoginTypes.pincode'),
          value: 'PINCODE'
        }
      ]

      this.afterReceiptBehaviours = [
        {
          name: this.$t('$vuetify.cashRegister.afterReceiptBehaviours.emptyBasket'),
          value: 'EMPTY_BASKET'
        },
        {
          name: this.$t('$vuetify.cashRegister.afterReceiptBehaviours.showCashRegs'),
          value: 'SHOW_CASH_REGS'
        },
        {
          name: this.$t('$vuetify.cashRegister.afterReceiptBehaviours.showAllReceipts'),
          value: 'SHOW_ALL_RECEIPTS'
        }
      ]

      this.registerLoginType = this.registerLoginTypes[0]
      this.afterReceiptBehaviour = this.afterReceiptBehaviours[0]

      this.registerType = this.registerTypes.find(
        (type) => !type.disabled
      ).value
    },
    close () {
      this.$emit('close')
      this.visible = false
      this.$refs.addCashRegisterForm.reset()
      this.$refs.deposit.$el.getElementsByTagName(
        'input'
      )[0].value = ''
      this.deposit = ''
    },
    submit () {
      const that = this
      if (!this.$refs.addCashRegisterForm.validate()) return
      this.submitting = true

      try {
        const reqId = uuidv4()
        const payload = {
          action: {
            operation: 'set',
            entity: 'cash_register',
            params: {
              name: this.registerName,
              number: parseInt(this.registerId),
              company_id: state.getCurrentCompany().id,
              location_id: state.getPointOfSale().id,
              type: this.registerType,
              view_type: 'GROUP_BY_CATEGORIES',
              login_type: this.registerLoginType.value,
              after_receipt_behaviour: this.afterReceiptBehaviour.value
            }
          }
        }

        if (this.selectedPrinter && this.selectedPrinter !== '') {
          payload.action.params.printer = this.selectedPrinter
        }

        const deposit = this.$refs.deposit.currencyToFloat(this.deposit) * 100
        if (deposit && deposit > 0) payload.action.params.deposit = deposit

        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'cashregister',
            payload: btoa(
              unescape(encodeURIComponent(JSON.stringify(payload)))
            )
          })
          .then(function (doc) {
            that.$emit('success', payload.action.params)
            setTimeout(() => {
              that.$refs.addCashRegisterForm.reset()
              that.$refs.deposit.$el.getElementsByTagName(
                'input'
              )[0].value = ''
              that.visible = false
            }, 100)
          })
          .catch(function (error) {
            // console.error('Error writing document: ', error)
            that.showMsgBox({
              text: error || 'Internal error',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
            that.submitting = false
          })
          .finally(() => {})
      } catch (error) {
        that.showMsgBox({
          text: error || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        that.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.modal-header {
  display: flex; align-items: center;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #F1F5F9;
}
.modal-title { font-size: 16px; font-weight: 700; color: #1e293b; }
.modal-close-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
}
.modal-close-btn:hover { background: #FEE2E2; color: #DC2626; }
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 20px;
  border-top: 1px solid #F1F5F9;
}
.btn-create-modal {
  display: flex; align-items: center; gap: 6px;
  padding: 12px 24px;
  background-color: #00BCD4 !important;
  background: #00BCD4 !important;
  color: #ffffff !important;
  border-radius: 10px;
  border: none !important;
  font-size: 13px; font-weight: 700;
  cursor: pointer; letter-spacing: 0;
  text-transform: none;
  box-shadow: 0 2px 8px rgba(0,188,212,0.35);
  transition: background-color 0.15s, box-shadow 0.15s;
}
.btn-create-modal:hover:not(:disabled) { background-color: #0097A7 !important; background: #0097A7 !important; }
.btn-create-modal:disabled { opacity: 0.45 !important; cursor: not-allowed; box-shadow: none; }
.form-input >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F8FAFC !important;
  min-height: 40px !important;
}
.form-input >>> fieldset { border-color: #E2E8F0 !important; border-radius: 8px !important; }
.form-input >>> .v-input__slot:hover fieldset { border-color: #00BCD4 !important; }
.form-input.v-input--is-focused >>> fieldset { border-color: #00BCD4 !important; border-width: 2px !important; }
.form-input >>> input { font-size: 13px !important; }
</style>
